class MHeader extends HTMLElement {
  constructor() {
    super();
    this.selectors = {
      headers: ['header'],
      logos: ['.m-logo'],
      topbar: '.m-topbar',
      headerWrapper: '.m-header__wrapper',
      topbarClose: '.m-topbar__close',
    };
    this.domNodes = queryDomNodes(this.selectors, this);
    this.innerWidth = window.innerWidth;
    this.headerOffsetTop = this.domNodes.headerWrapper.offsetTop;
    this.headerHeight = this.domNodes.headerWrapper.offsetHeight;
    this.stickyHeader = this.dataset.sticky;

    this.classes = {
      scrollUp: 'scroll-up',
      scrollDown: 'scroll-down',
      stuck: 'stuck',
      always: 'header-sticky-always',
      headerScrollUp: 'header-scroll-up',
      headerScrollDown: 'header-scroll-down',
    };
    this.init();
  }

  init() {
    this.transparentHeader =
      this.domNodes &&
      this.domNodes.headers[0] &&
      this.domNodes.headers[0].dataset.transparent === 'true';
    this.initAddon();
    this.handleSticky();
    document.addEventListener('matchMobile', () => this.handleSticky());
    document.addEventListener('unmatchMobile', () => this.handleSticky());
    this.siteNav = new SiteNav(this);
    window.__sfHeader = this;
    window.addEventListener('resize', () => {
      this.innerWidth = window.innerWidth;
    });
  }

  initAddon() {
    this.megamenu = new Megamenu(this);
    if (Shopify.designMode) {
      MinimogTheme = MinimogTheme || {};
      MinimogTheme &&
        MinimogTheme.Wishlist &&
        MinimogTheme.Wishlist.updateWishlistCount();
    }
  }
  handleSticky() {
    let extraSpace = 20;
    const sectionGroups = document.querySelectorAll(
      '.shopify-section-group-header-group'
    );
    sectionGroups.forEach((section) => {
      if (
        !section.classList.contains('m-section-header') &&
        !section.classList.contains('m-section-scaling-logo')
      ) {
        extraSpace += section.offsetHeight;
      }
    });
    const topBar = document.querySelector('.m-topbar');
    if (topBar) extraSpace += topBar.offsetHeight;

    let lastScroll = 0;
    window.addEventListener('scroll', () => {
      const currentScroll = window.scrollY;
      if (currentScroll <= extraSpace) {
        this.classList.remove(
          this.classes.scrollUp,
          this.classes.stuck,
          this.classes.always
        );
        document.body.classList.remove(
          this.classes.headerScrollUp,
          this.classes.headerScrollDown
        );
        return;
      }

      if (this.stickyHeader === 'on_scroll_up') {
        this.classList.add(this.classes.stuck);
      } else if (this.stickyHeader === 'always') {
        this.classList.add(this.classes.always);
      }

      if (
        currentScroll > this.headerHeight + extraSpace &&
        currentScroll > lastScroll &&
        !this.classList.contains(this.classes.scrollDown)
      ) {
        this.classList.remove(this.classes.scrollUp);
        document.body.classList.remove(this.classes.headerScrollUp);
        this.classList.add(this.classes.scrollDown);
        document.body.classList.add(this.classes.headerScrollDown);
      } else if (
        currentScroll < lastScroll &&
        this.classList.contains(this.classes.scrollDown)
      ) {
        this.classList.remove(this.classes.scrollDown);
        document.body.classList.remove(this.classes.headerScrollDown);
        this.classList.add(this.classes.scrollUp);
        document.body.classList.add(this.classes.headerScrollUp);
      }
      lastScroll = currentScroll;
    });
  }
}
customElements.define('m-header', MHeader);
// Remove configured promo menu links for visitors outside India
(function () {
  function removePromoLinksForNonIndia() {
    var headerEl = document.querySelector('m-header');
    var country = '';
    if (headerEl) country = headerEl.getAttribute('data-visitor-country') || '';
    country = (
      country ||
      window.__visitorCountry ||
      document.documentElement.getAttribute('data-visitor-country') ||
      ''
    )
      .toString()
      .trim()
      .toLowerCase();
    if (!country) return;
    if (country === 'in' || country === 'india') return;

    var patterns = [];
    if (headerEl) {
      var attr = headerEl.getAttribute('data-international-hide-links');
      if (attr) {
        try {
          patterns = JSON.parse(attr);
        } catch (e) {
          // fallback: split by newlines
          patterns = attr
            .replace(/\r/g, '')
            .split('\n')
            .map(function (s) {
              return s.trim();
            })
            .filter(Boolean);
        }
      }
    }

    // Fallback to the two known promo texts if no patterns provided
    if (!patterns || patterns.length === 0) {
      patterns = ['Buy any 2 @999', 'Buy any 3 @1499'];
    }

    function normalizeText(s) {
      return (s || '').replace(/\s+/g, ' ').trim().toLowerCase();
    }
    function normalizeHref(s) {
      return (s || '')
        .trim()
        .replace(/\?[^#]*$/, '')
        .toLowerCase();
    }

    var links = document.querySelectorAll('a');
    links.forEach(function (a) {
      var href = a.getAttribute('href') || '';
      var txt = a.textContent || '';
      var hrefNorm = normalizeHref(href);
      var txtNorm = normalizeText(txt);

      var shouldRemove = patterns.some(function (p) {
        if (!p) return false;
        var pTrim = p.toString().trim();
        var pLower = pTrim.toLowerCase();
        // treat values that look like URLs or start with / as href matches
        if (pLower.indexOf('http') === 0 || pLower.indexOf('/') === 0) {
          return hrefNorm.indexOf(pLower) !== -1;
        }
        // fallback: match within visible text
        if (txtNorm.indexOf(pLower) !== -1) return true;
        // also check href contains the pattern without spaces
        if (hrefNorm.indexOf(pLower.replace(/\s+/g, '')) !== -1) return true;
        return false;
      });

      if (shouldRemove) {
        var li = a.closest('li');
        if (li && li.parentNode) li.parentNode.removeChild(li);
        else if (a.parentNode) a.parentNode.removeChild(a);
      }
    });
  }

  if (document.readyState === 'loading')
    document.addEventListener('DOMContentLoaded', removePromoLinksForNonIndia);
  else removePromoLinksForNonIndia();
  document.addEventListener(
    'shopify:section:load',
    removePromoLinksForNonIndia
  );
  document.addEventListener('matchTablet', removePromoLinksForNonIndia);
  document.addEventListener('unmatchTablet', removePromoLinksForNonIndia);
})();
